import { Select } from 'foundations-components/transitional/components/Select';
import { getSelectionFromToolsAndCategories, getToolsAndCategoriesFromSelection, getTopicOptions } from '../../utils/topicSelectUtils';
import { useMemo } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const ButtonContent = ({
  selectedTopicsCount
}) => {
  if (selectedTopicsCount === 0) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.myTeam.filters.catalogTopics.noneSelectedLabel"
    });
  }
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: "learningCenter.myTeam.filters.catalogTopics.someSelectedLabel",
    options: {
      count: selectedTopicsCount
    }
  });
};
const TopicSelect = ({
  onChange,
  selectedTopics
}) => {
  const selectedTopicsCount = useMemo(() => Object.values(selectedTopics).flat().length, [selectedTopics]);
  const handleChange = newValues => {
    const toolsAndCategories = getToolsAndCategoriesFromSelection(newValues);
    onChange(toolsAndCategories);
  };
  return /*#__PURE__*/_jsx(Select, {
    ButtonContent: ButtonContent,
    anchorType: "button",
    buttonContentProps: {
      selectedTopicsCount
    },
    buttonUse: "transparent",
    menuWidth: 350,
    minimumSearchCount: 1,
    multi: true,
    onChange: event => handleChange(event.target.value),
    options: getTopicOptions(),
    value: getSelectionFromToolsAndCategories(selectedTopics)
  });
};
export default TopicSelect;